import styled from 'styled-components';
import { useState } from 'react';
import { Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import { Link } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import SettingsTable, {
	SettingsEmptyState,
} from 'packages/kakapo-ui-kit/components/common/SettingsTable';
import { ParagraphSmall } from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';
import GoalDriverEdit from 'packages/kakapo-ui-kit/components/goals/drivers/GoalDriverEdit';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

const AnchorElement = styled(Link)`
	color: ${(props) => props.theme.colors.primary};
	text-decoration: underline;
`;

export default function GoalDriverSettingsContainer() {
	const { t } = useTranslation();

	const [adding, setAdding] = useState(false);
	const [showArchived, setShowArchived] = useState(false);

	const queries = {
		active: graphql.useGoalDriversQuery(),
		archive: graphql.useGoalDriversLazyQuery({ variables: { isArchived: true } }),
	};

	const goalDrivers = queries.active?.data?.goalDrivers;
	const archivedGoalDrivers = queries.archive[1]?.data?.goalDrivers;

	const onRefresh = async () => {
		await queries.active.refetch();
		await queries.archive[1]?.refetch?.();
		setAdding(false);
	};

	return (
		<>
			<Flex flexDirection="column" mb={4}>
				<SettingsTable
					title={t('organization.drivers.title')}
					description={t('organization.drivers.description')}
					toolbar={
						<Button size={ButtonSize.Medium} onClick={() => setAdding(true)}>
							{t('common.add')}
						</Button>
					}
				>
					{goalDrivers ? (
						goalDrivers.length > 0 || adding ? (
							<>
								{goalDrivers.map((driver) => (
									<GoalDriverEdit
										key={driver.id}
										driver={driver as graphql.GoalDriver}
										onRefresh={onRefresh}
									/>
								))}
								{adding && <GoalDriverEdit onRefresh={onRefresh} />}
							</>
						) : (
							<SettingsEmptyState>{t('organization.drivers.empty')}</SettingsEmptyState>
						)
					) : (
						<Spinner isLoading />
					)}
				</SettingsTable>
			</Flex>

			{showArchived ? (
				<Flex flexDirection="column" mb={4}>
					<SettingsTable
						title={t('organization.drivers.archived.title')}
						description={t('organization.drivers.archived.description')}
					>
						{archivedGoalDrivers ? (
							archivedGoalDrivers.length > 0 || adding ? (
								<>
									{archivedGoalDrivers.map((driver) => (
										<GoalDriverEdit
											key={driver.id}
											driver={driver as graphql.GoalDriver}
											onRefresh={onRefresh}
										/>
									))}
									{adding && <GoalDriverEdit onRefresh={onRefresh} />}
								</>
							) : (
								<SettingsEmptyState>{t('organization.drivers.archived.empty')}</SettingsEmptyState>
							)
						) : (
							<Spinner isLoading />
						)}
					</SettingsTable>
				</Flex>
			) : (
				<Flex px={3}>
					<AnchorElement
						to="/settings/goal-drivers"
						onClick={() => {
							setShowArchived(true);
							queries.archive[0]();
						}}
					>
						<ParagraphSmall>{t('organization.drivers.archived.button.title')}</ParagraphSmall>
					</AnchorElement>
				</Flex>
			)}
		</>
	);
}
